<template>
    <footer class="footer">
        <div class="footer__container -wrap">
            <Logo class="footer__logo" type="footer-logo"/>
        </div>
        <div class="footer__container -wrap">
            <ul class="footer__list">
                <li class="footer__line -title" v-html="$t('Footer.eduhouse')"></li>
                <li class="footer__line -address" v-html="addressLine"></li>
                <li class="footer__line " v-html="$t('Footer.row1_label')"></li>
                <img src="@/assets/images/ISO27001-ISO27701-certificate-logo.png" class="footer__iso-certificate-logo" :alt="$t('Footer.iso_certificate_alt')"/>
            </ul>

            <ul class="footer__list --support">
                <li class="footer__line -title" v-html="$t('Footer.customer_support')"></li>
                <li class="footer__line -open-hours" v-html="$t('Footer.open_hours')"></li>
                <FooterHubspotChat />
                <FooterLink :url="$t('Footer.contact_us_url')" :label="$t('Footer.contact_us')" icon="contact" />
                <FooterLink :url="$t('Footer.email')" :label="$t('Footer.email')" icon="email" />
                <FooterLink :url="$t('Footer.phone_number')" :label="$t('Footer.phone_number')" icon="phone" />
                <FooterLink :url="$t('Footer.faq_url')" :label="$t('Footer.faq')" icon="faq" />
            </ul>

            <ul class="footer__list -privacy">
                <li class="footer__line -title" v-html="$t('Footer.privacy_and_terms')"></li>
                <FooterLink :url="$t('Footer.row3_url')" :label="$t('Footer.row3_label')" />
                <FooterLink :url="$t('Footer.row4_url')" :label="$t('Footer.row4_label')" />
                <a class="footer__consent-button" href="javascript: Cookiebot.show()" v-html="$t('Footer.cookies')"></a>
            </ul>
            <ul class="footer__list">
                <FooterSocials class="footer__socials" />
                <FooterLink :url="'https://' + $t('StoreMenu.home')" :label="$t('StoreMenu.home')" class="footer__homepage" />
                <FooterSubscribe v-if="showFooterSubscribe && !isTabletAndMobileView" />
            </ul>
        </div>
        <FooterSubscribe v-if="showFooterSubscribe && isTabletAndMobileView" class="footer__subscribe"/>
    </footer>
</template>

<script>
    import FooterLink from 'components/layout/footer/footer-link'
    import FooterSubscribe from 'components/layout/footer/footer-subscribe'
    import FooterSocials from 'components/layout/footer/footer-socials'
    import FooterHubspotChat from 'components/layout/footer/footer-hubspot-chat'
    import Logo from 'components/layout/Logo'
    import { mapGetters } from 'vuex'
    export default {
        name: 'footer',
        components: {
            Logo,
            FooterSocials,
            FooterSubscribe,
            FooterLink,
            FooterHubspotChat
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                showFooterSubscribe: 'User/getShowFooterSubscribe'
            }),
            addressLine () {
                return this.$t('Footer.address_line_1') + ', ' + this.$t('Footer.address_line_2')
            },
            isTabletAndMobileView () {
                return this.$mq.includes('mobile_sm') || this.$mq.includes('mobile_md') || this.$mq.includes('desktop_l') || this.$mq.includes('desktop_xl')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .footer {
        background: $eerie_black;
        color: $white;
        padding: 50px 0 100px;
        transition: 0.15s padding-left ease-out;

        &__container {
            margin: 0 0 0 26px;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            height: auto;
            max-width: 1284px;

            [class*="desktop_x"] &,
            [class*="desktop_l"] &,
            [class*="mobile_md"] & {
                flex-wrap: wrap;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                margin: 0 auto;
            }

            [class="desktop_xxl"] & ,
            [class="desktop_xxxl"] & {
                flex-wrap: nowrap;
            }
        }

        &__logo {
            padding: 0 0 42px;
        }

        &__list {
            font-size: 1.6rem;
            min-width: 220px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex-basis: 25%;
            margin-bottom: 42px;

            [class*="desktop_xl"] &,
            [class*="desktop_l"] &,
            [class*="mobile_md"] & {
                flex-basis: 50%;
            }

            &.-privacy {
                max-width: 300px;
                margin: 0 0 60px;

                [class*="desktop_x"] & {
                    margin: 0;
                    flex-basis: 33.33%;
                }
            }
        }

        &__title {
            font-family: Nunito-Bold, sans-serif;
            font-size: 2rem;
        }

        &__line {
            list-style: none;
            font-size: 1.6rem;
            color: $white;
            position: relative;
            margin: 0 0 15px 0;
            display: flex;
            align-items: center;

            &:before {
                font-family: 'icomoon';
                font-size: 2rem;
                position: absolute;
                margin: 0 0 0 -35px;
            }

            &.-icon {
                margin: 0 0 15px 35px;

            }

            &.-title {
                font-family: Nunito-ExtraBold, sans-serif;
            }

            &.-open-hours {
                font-family: Nunito-Regular, sans-serif;
                font-size: 15px;
            }

            &.-chat-with-us:before {
                content: '\e953';
            }
        }

        &__iso-certificate-logo {
            margin: 15px 0 0;
            width: 200px;
        }

        &__homepage {
            margin: 0 0 30px;
        }

        &__consent-button {
            text-decoration: none;
            list-style: none;
            font-size: 1.6rem;
            margin-bottom: 6px;
            color: $white;

            &:hover {
                text-decoration: underline;
                text-decoration-color: $gray_chateau;
            }
        }

        &__subscribe {
            padding: 0 20px;

            [class*="mobile_sm"] & {
                margin: 0 0 0 26px;
            }
        }
    }
</style>
